import { Component } from '@theme/component';

/** @extends {Component<{links: HTMLAnchorElement[]}>} */
class LumenelleHelpNav extends Component {
  #abort;
  #frame;

  connectedCallback() {
    super.connectedCallback();
    this.#connect();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#connect();
  }

  disconnectedCallback() {
    this.#clean();
    super.disconnectedCallback();
  }

  #clean() {
    this.#abort?.abort();
    cancelAnimationFrame(this.#frame);
    this.#frame = undefined;
  }

  #connect() {
    this.#clean();
    this.#abort = new AbortController();
    const options = { passive: true, signal: this.#abort.signal };
    document.addEventListener('scroll', this.#schedule, { ...options, capture: true });
    window.addEventListener('resize', this.#schedule, options);
    this.#update();
  }

  #schedule = () => {
    if (this.#frame !== undefined) return;
    this.#frame = requestAnimationFrame(() => {
      this.#frame = undefined;
      this.#update();
    });
  };

  #update() {
    const links = this.refs.links || [];
    let selected = links[0];
    for (const link of links) {
      const target = document.getElementById(link.hash.slice(1));
      if (target && target.getBoundingClientRect().top <= 180) selected = link;
    }
    for (const link of links) {
      if (link === selected) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    }
  }
}

if (!customElements.get('lumenelle-help-nav-component')) {
  customElements.define('lumenelle-help-nav-component', LumenelleHelpNav);
}
